module.exports = require('./StatsPage');